/**
 * OUTLET034 — "Monte seu kit" (blocks/product-combo-builder.liquid)
 *
 * - One step per kit item; per-option availability is computed against the other
 *   selected options (sold-out combinations are disabled dynamically).
 * - Optional color selector built from sibling products (window.Outlet034Colors).
 * - Optional summary view before adding (thumbnail, options, price, edit link, totals).
 * - Adds every item in one /cart/add.js call with properties _kit / _kit_id / _kit_item,
 *   then dispatches Horizon's CartAddEvent ('cart:update') with the sections the cart
 *   drawer needs and the TOTAL cart item count (header counter), and opens the drawer.
 */
(function () {
  'use strict';

  var COLOR_OPTION_NAMES = ['cor', 'cores', 'color', 'colour', 'colors'];
  var SIZE_OPTION_NAMES = ['tamanho', 'tamanhos', 'tam', 'size', 'sizes', 'numeração', 'numeracao'];
  var FETCH_TIMEOUT = 8000;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function fetchWithTimeout(url, opts, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || FETCH_TIMEOUT) : null;
    var o = Object.assign({}, opts || {});
    if (ctrl) o.signal = ctrl.signal;
    return fetch(url, o).finally(function () { if (timer) clearTimeout(timer); });
  }

  function rootUrl(path) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r + path;
  }

  function sizeUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    try {
      var url = new URL(u, window.location.origin);
      url.searchParams.set('width', String(w));
      return url.toString();
    } catch (e) {
      return u;
    }
  }

  function isColorOption(name) {
    return COLOR_OPTION_NAMES.indexOf(String(name || '').trim().toLowerCase()) !== -1;
  }

  function isSizeOption(name) {
    return SIZE_OPTION_NAMES.indexOf(String(name || '').trim().toLowerCase()) !== -1;
  }

  /**
   * Foto do item do kit: segue só as opções de APARÊNCIA (cor, marca, estampa...),
   * nunca o tamanho. Trocar o tamanho não troca a foto. Enquanto alguma opção de
   * aparência não foi escolhida, mostra a foto principal do produto.
   */
  function imageFor(product, sel) {
    var keys = [];
    product.options.forEach(function (n, i) { if (!isSizeOption(n)) keys.push(i); });
    if (!keys.length) return product.image;
    var chosen = keys.every(function (i) { return sel && sel[i] != null; });
    if (!chosen) return product.image;
    var cands = product.variants.filter(function (v) {
      return v.image && keys.every(function (i) { return v.options[i] === sel[i]; });
    });
    if (!cands.length) return product.image;
    var av = cands.find(function (v) { return v.available; });
    return (av || cands[0]).image;
  }

  /* ---------------- cor virtual (produto sem opção "Cor") ----------------
   * Alguns produtos vêm da Bling sem a opção Cor, mas cada variação tem a foto
   * de uma cor diferente (ex.: Camiseta Multimarcas: Marca + Tamanho). Aqui a cor
   * é LIDA DA FOTO: amostra o peito da peça (centro da imagem), descarta sombras
   * e brilhos, e converte no nome mais próximo de uma paleta de moda. Só usa a
   * foto PRÓPRIA da variação (texto alternativo = SKU); variações sem foto própria
   * ficam como "Sortida". A opção vira miniaturas com a foto, como as cores reais.
   */
  var COLOR_PALETTE = [
    ['Preto', [26, 26, 26]], ['Branco', [242, 242, 244]], ['Off White', [235, 232, 222]],
    ['Cinza', [188, 190, 193]], ['Chumbo', [72, 74, 78]], ['Marinho', [33, 40, 59]],
    ['Azul', [45, 85, 160]], ['Azul claro', [150, 185, 222]], ['Verde', [29, 172, 121]],
    ['Verde militar', [105, 108, 86]], ['Amarelo', [245, 218, 120]], ['Bege', [212, 188, 154]],
    ['Caqui', [178, 158, 112]], ['Marrom', [108, 80, 71]], ['Vinho', [118, 36, 58]],
    ['Vermelho', [192, 40, 44]], ['Rosa', [232, 165, 180]], ['Laranja', [243, 160, 96]],
    ['Lilás', [172, 152, 204]]
  ];
  var VIRTUAL_COLOR_NAME = 'Cor';
  var VIRTUAL_COLOR_UNKNOWN = 'Sortida';
  var colorCache = {};

  function nearestColorName(rgb) {
    var best = null, min = Infinity;
    COLOR_PALETTE.forEach(function (c) {
      var p = c[1];
      // distância "redmean": aproxima a percepção humana melhor que RGB puro
      var rm = (rgb[0] + p[0]) / 2, dr = rgb[0] - p[0], dg = rgb[1] - p[1], db = rgb[2] - p[2];
      var d = (2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db;
      if (d < min) { min = d; best = c[0]; }
    });
    return best;
  }

  function sampleColor(src) {
    if (colorCache[src]) return colorCache[src];
    colorCache[src] = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0);
          var x0 = Math.round(w * 0.4), y0 = Math.round(h * 0.36);
          var d = ctx.getImageData(x0, y0, Math.max(1, Math.round(w * 0.2)), Math.max(1, Math.round(h * 0.16))).data;
          var px = [];
          for (var i = 0; i < d.length; i += 4) px.push([d[i], d[i + 1], d[i + 2]]);
          px.sort(function (a, b) { return (a[0] + a[1] + a[2]) - (b[0] + b[1] + b[2]); });
          px = px.slice(Math.floor(px.length * 0.2), Math.ceil(px.length * 0.8)); // sem sombra/brilho
          var r = 0, g = 0, b = 0;
          px.forEach(function (p) { r += p[0]; g += p[1]; b += p[2]; });
          var n = px.length || 1;
          resolve(nearestColorName([r / n, g / n, b / n]));
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = sizeUrl(src, 120);
    });
    return colorCache[src];
  }

  function ownPhoto(v) {
    return !!(v.image && v.sku && v.imageAlt && String(v.imageAlt).trim().toUpperCase() === String(v.sku).trim().toUpperCase());
  }

  /** Resolve com o produto acrescido da opção "Cor" virtual (ou o próprio produto, se não couber). */
  function withVirtualColor(product) {
    if (product.virtualColor || product.options.some(isColorOption)) return Promise.resolve(product);
    var own = product.variants.filter(ownPhoto);
    var srcs = [];
    own.forEach(function (v) { if (srcs.indexOf(v.image) === -1) srcs.push(v.image); });
    if (srcs.length < 2) return Promise.resolve(product);
    return Promise.all(srcs.map(sampleColor)).then(function (names) {
      var bySrc = {};
      srcs.forEach(function (src, i) { bySrc[src] = names[i]; });
      if (names.filter(Boolean).length < 2) return product;
      var at = product.options.findIndex(isSizeOption);
      if (at < 0) at = product.options.length;
      var options = product.options.slice();
      var upper = options.length && options.every(function (n) { return n === String(n).toUpperCase(); });
      options.splice(at, 0, upper ? VIRTUAL_COLOR_NAME.toUpperCase() : VIRTUAL_COLOR_NAME);
      var variants = product.variants.map(function (v) {
        var name = ownPhoto(v) ? (bySrc[v.image] || VIRTUAL_COLOR_UNKNOWN) : VIRTUAL_COLOR_UNKNOWN;
        if (upper) name = name.toUpperCase();
        var opts = v.options.slice();
        opts.splice(at, 0, name);
        // Foto que não é da própria variação (provisória) não representa a cor: não usa.
        return Object.assign({}, v, { options: opts, image: ownPhoto(v) ? v.image : null });
      });
      return Object.assign({}, product, { options: options, variants: variants, virtualColor: at });
    });
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  /** Normalizes a /products/<handle>.js payload into the step product shape. */
  function normalizeProductJs(p) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    return {
      handle: p.handle,
      title: p.title,
      image: p.featured_image ? sizeUrl(p.featured_image, 400) : '',
      options: names,
      variants: (p.variants || []).map(function (v) {
        var opts = v.options || names.map(function (_, i) { return v['option' + (i + 1)]; });
        return {
          id: v.id,
          available: !!v.available,
          price: v.price,
          title: v.title,
          image: v.featured_image && v.featured_image.src ? sizeUrl(v.featured_image.src, 400) : null,
          sku: v.sku || '',
          imageAlt: v.featured_image ? v.featured_image.alt || '' : '',
          options: opts,
        };
      }),
    };
  }

  function hasOnlyDefault(product) {
    return product.variants.length === 1 && product.options.length <= 1 &&
      /^default title$/i.test(String(product.variants[0].options[0] || ''));
  }

  function KitBuilder(root) {
    this.root = root;
    var cfgEl = $(root, '[data-kit034-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { labels: {} };
    this.L = this.cfg.labels || {};
    this.money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: this.cfg.currency || 'BRL' });

    this.bar = $(root, '[data-kit034-bar]');
    this.fillEl = $(root, '[data-kit034-fill]');
    this.progressText = $(root, '[data-kit034-progress-text]');
    this.prevBtn = $(root, '[data-kit034-prev]');
    this.nextBtn = $(root, '[data-kit034-next]');
    this.msg = $(root, '[data-kit034-message]');
    this.summary = this.cfg.showSummary ? $(root, '[data-kit034-summary]') : null;

    var self = this;
    this.steps = $$(root, '[data-kit034-step]').map(function (el) {
      var data = JSON.parse($(el, '[data-kit034-product]').textContent);
      var step = { el: el, product: data, original: data, selection: [], variant: null };
      step.selection = data.options.map(function () { return null; });
      // Pre-selected pills (options with a single value) rendered by Liquid.
      $$(el, '[data-kit034-value].is-selected').forEach(function (pill) {
        step.selection[Number(pill.dataset.optionIndex)] = pill.dataset.kit034Value;
      });
      return step;
    });
    this.total = this.steps.length;
    this.current = 0;
    this.busy = false;

    this.steps.forEach(function (step) { self.refreshStep(step); });
    this.bind();
    this.go(0, false);
    this.initSiblings();
    this.initVirtualColors();
  }

  /** Produtos sem opção Cor: acrescenta a cor lida das fotos e redesenha as opções do passo. */
  KitBuilder.prototype.initVirtualColors = function () {
    var self = this;
    this.steps.forEach(function (step) { self.applyVirtualColor(step, step.product); });
  };

  KitBuilder.prototype.applyVirtualColor = function (step, product) {
    var self = this;
    return withVirtualColor(product).then(function (p) {
      if (p === product || step.product.handle !== p.handle) return;
      // Mantém o que o cliente já escolheu (por nome de opção).
      var prev = {};
      step.product.options.forEach(function (n, i) { prev[n] = step.selection[i]; });
      step.product = p;
      if (step.original.handle === p.handle) step.original = p;
      step.selection = p.options.map(function (n) { return prev[n] != null ? prev[n] : null; });
      self.renderOptions(step);
      self.refreshStep(step);
      self.updateNav();
    });
  };

  KitBuilder.prototype.formatMoney = function (cents) {
    return this.money.format((Number(cents) || 0) / 100);
  };

  /* ---------------- availability ---------------- */

  KitBuilder.prototype.matches = function (v, sel, skipIdx) {
    for (var j = 0; j < sel.length; j++) {
      if (j === skipIdx || sel[j] == null) continue;
      if (v.options[j] !== sel[j]) return false;
    }
    return true;
  };

  /** Variant can be picked in this step: available and, when stock is tracked, not
   *  already used up by the other steps of the kit (same variant chosen twice). */
  KitBuilder.prototype.canUse = function (step, v) {
    if (!v.available) return false;
    if (v.max == null) return true;
    var used = 0;
    this.steps.forEach(function (s) {
      if (s !== step && s.variant && s.variant.id === v.id) used++;
    });
    return used < v.max;
  };

  KitBuilder.prototype.isValueAvailable = function (step, idx, value, sel) {
    var self = this;
    // Cor virtual depende da marca/tamanho: a disponibilidade das outras opções ignora a cor escolhida.
    var vc = step.product.virtualColor;
    if (vc != null && idx !== vc && sel[vc] != null && !isSizeOption(step.product.options[idx])) { sel = sel.slice(); sel[vc] = null; }
    return step.product.variants.some(function (v) {
      return v.options[idx] === value && self.matches(v, sel, idx) && self.canUse(step, v);
    });
  };

  KitBuilder.prototype.select = function (step, idx, value) {
    var self = this;
    var product = step.product;
    var sel = step.selection;
    var usable = function (v) { return self.canUse(step, v); };
    // Value impossible regardless of other selections → ignore.
    if (!product.variants.some(function (v) { return v.options[idx] === value && usable(v); })) return false;
    sel[idx] = value;
    // Drop other selections that conflict with this choice.
    var fits = function (test) {
      return product.variants.some(function (v) { return usable(v) && self.matches(v, test, -1); });
    };
    if (!fits(sel)) {
      for (var j = 0; j < sel.length; j++) {
        if (j === idx || sel[j] == null) continue;
        var keep = sel[j];
        sel[j] = null;
        var test = sel.slice();
        test[j] = keep;
        if (fits(test)) sel[j] = keep;
      }
    }
    return true;
  };

  KitBuilder.prototype.refreshStep = function (step) {
    var self = this;
    var product = step.product;
    var sel = step.selection;

    // Cor virtual: se só uma cor é possível para a marca/tamanho escolhidos, já seleciona.
    var vc = product.virtualColor;
    if (vc != null && sel[vc] == null) {
      var others = sel.some(function (x, i) { return i !== vc && x != null; });
      if (others) {
        var possible = [];
        product.variants.forEach(function (v) {
          if (self.matches(v, sel, vc) && self.canUse(step, v) && possible.indexOf(v.options[vc]) === -1) possible.push(v.options[vc]);
        });
        if (possible.length === 1) sel[vc] = possible[0];
      }
    }

    if (hasOnlyDefault(product)) {
      step.variant = this.canUse(step, product.variants[0]) ? product.variants[0] : null;
    } else {
      var complete = sel.every(function (s) { return s != null; });
      step.variant = complete
        ? product.variants.find(function (v) { return self.matches(v, sel, -1) && self.canUse(step, v); }) || null
        : null;
    }

    $$(step.el, '[data-kit034-option-group]').forEach(function (group) {
      var idx = Number(group.dataset.kit034OptionGroup);
      var current = $(group, '[data-kit034-option-current]');
      if (current) current.textContent = sel[idx] || '';
      $$(group, '[data-kit034-value]').forEach(function (pill) {
        var val = pill.dataset.kit034Value;
        var avail = self.isValueAvailable(step, idx, val, sel);
        var selected = sel[idx] === val;
        pill.classList.toggle('is-selected', selected);
        pill.classList.toggle('is-unavailable', !avail);
        // Cor virtual: mostra só as cores que existem para a marca/tamanho escolhidos.
        if (product.virtualColor === idx) pill.hidden = !avail && !selected;
        pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (avail) pill.removeAttribute('aria-disabled'); else pill.setAttribute('aria-disabled', 'true');
        var sr = $(pill, '[data-kit034-sr-state]');
        if (sr) sr.textContent = avail ? '' : ' (' + (self.L.unavailable || '') + ')';
        if (pill.hasAttribute('aria-label')) {
          pill.setAttribute('aria-label', val + (avail ? '' : ' (' + (self.L.unavailable || '') + ')'));
        }
      });
    });

    // Card: image / price follow the chosen variant (or the chosen color).
    var img = $(step.el, '[data-kit034-card-img]');
    var priceEl = $(step.el, '[data-kit034-card-price]');
    var nameEl = $(step.el, '[data-kit034-card-name]');
    var image = imageFor(product, sel) || product.image;
    if (img && image && img.getAttribute('src') !== image) img.src = image;
    if (nameEl && nameEl.textContent !== product.title) nameEl.textContent = product.title;
    if (priceEl) {
      var price = step.variant ? step.variant.price : Math.min.apply(null, product.variants.map(function (v) { return v.price; }));
      priceEl.textContent = this.formatMoney(price);
    }
  };

  /* ---------------- options markup (after a sibling color swap) ---------------- */

  KitBuilder.prototype.renderOptions = function (step) {
    var container = $(step.el, '[data-kit034-options]');
    if (!container) return;
    container.innerHTML = '';
    var product = step.product;
    if (hasOnlyDefault(product)) return;
    var self = this;
    var uid = this.root.id + '-s' + step.el.dataset.kit034Step + '-x' + Date.now().toString(36);

    product.options.forEach(function (name, idx) {
      var values = [];
      product.variants.forEach(function (v) {
        if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });
      if (product.virtualColor === idx) {
        values.sort(function (a, b) {
          var ua = a.toUpperCase() === VIRTUAL_COLOR_UNKNOWN.toUpperCase(), ub = b.toUpperCase() === VIRTUAL_COLOR_UNKNOWN.toUpperCase();
          return ua === ub ? 0 : ua ? 1 : -1;
        });
      }
      var useImages = self.cfg.swatchImages && isColorOption(name);

      var group = document.createElement('div');
      group.className = 'kit034__group';
      group.dataset.kit034OptionGroup = String(idx);

      var label = document.createElement('p');
      label.className = 'kit034__label';
      label.id = uid + '-o' + idx;
      label.textContent = name;
      var cur = document.createElement('span');
      cur.className = 'kit034__label-value';
      cur.setAttribute('data-kit034-option-current', '');
      label.appendChild(cur);

      var list = document.createElement('div');
      list.className = 'kit034__values' + (useImages ? ' kit034__values--swatch' : '');
      list.setAttribute('role', 'group');
      list.setAttribute('aria-labelledby', label.id);

      values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kit034__pill';
        btn.dataset.kit034Value = val;
        btn.dataset.optionIndex = String(idx);
        btn.setAttribute('aria-pressed', 'false');
        var withImg = useImages && product.variants.find(function (v) { return v.options[idx] === val && v.image; });
        if (withImg) {
          btn.classList.add('kit034__pill--image');
          btn.setAttribute('aria-label', val);
          btn.title = val;
          var im = document.createElement('img');
          im.src = sizeUrl(withImg.image, 200);
          im.alt = '';
          im.loading = 'lazy';
          btn.appendChild(im);
        } else {
          btn.appendChild(document.createTextNode(val));
        }
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.setAttribute('data-kit034-sr-state', '');
        btn.appendChild(sr);
        list.appendChild(btn);
      });

      if (values.length === 1) step.selection[idx] = values[0];
      group.appendChild(label);
      group.appendChild(list);
      container.appendChild(group);
    });
  };

  /* ---------------- sibling colors ---------------- */

  KitBuilder.prototype.initSiblings = function () {
    if (!this.cfg.showSiblings) return;
    var self = this;
    var run = function () {
      if (!window.Outlet034Colors) return;
      self.steps.forEach(function (step) { self.loadSiblings(step); });
    };
    if (window.Outlet034Colors) run();
    else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
    else setTimeout(run, 0);
  };

  KitBuilder.prototype.loadSiblings = function (step) {
    var self = this;
    var wrap = $(step.el, '[data-kit034-siblings]');
    var list = $(step.el, '[data-kit034-sibling-list]');
    if (!wrap || !list) return;
    var base = step.original;
    var ZC = window.Outlet034Colors;
    var group;
    try {
      group = ZC.getColorGroup(base.title, base.handle, base.image);
    } catch (e) {
      return;
    }
    Promise.resolve(group).then(function (g) {
      var members = (g && g.members) || [];
      if (members.length < 2) return;
      list.innerHTML = '';
      members.forEach(function (m) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kit034__swatch';
        btn.dataset.handle = m.handle;
        btn.title = m.color;
        btn.setAttribute('aria-label', fill(self.L.colorSiblingAria || '[cor]', { cor: m.color }));
        btn.setAttribute('aria-pressed', m.handle === step.product.handle ? 'true' : 'false');
        if (m.image) {
          var im = document.createElement('img');
          im.src = sizeUrl(m.image, 200);
          im.alt = '';
          im.loading = 'lazy';
          btn.appendChild(im);
        } else {
          btn.textContent = m.color;
        }
        btn.addEventListener('click', function () { self.swapProduct(step, m.handle, btn); });
        list.appendChild(btn);
      });
      wrap.hidden = false;
    }).catch(function () { /* no siblings → keep hidden */ });
  };

  KitBuilder.prototype.swapProduct = function (step, handle, btn) {
    if (handle === step.product.handle) return;
    var self = this;
    var list = btn.parentElement;
    var apply = function (product) {
      step.product = product;
      step.selection = product.options.map(function () { return null; });
      step.el.dataset.productHandle = product.handle;
      $$(list, '.kit034__swatch').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      self.renderOptions(step);
      self.refreshStep(step);
      self.updateNav();
      self.updateGallery(step);
    };
    if (handle === step.original.handle) {
      apply(step.original);
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    fetchWithTimeout(rootUrl('products/' + encodeURIComponent(handle) + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) { return withVirtualColor(normalizeProductJs(p)); })
      .then(function (p) { apply(p); })
      .catch(function () { self.showMessage(self.L.error, 'error'); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  };

  KitBuilder.prototype.updateGallery = function (step) {
    if (typeof window.Outlet034UpdateGallery !== 'function' || !step) return;
    window.Outlet034UpdateGallery(step.product.handle);
  };

  /* ---------------- navigation ---------------- */

  KitBuilder.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-kit034-value]');
      if (pill && self.root.contains(pill)) {
        var stepEl = pill.closest('[data-kit034-step]');
        var step = self.steps[Number(stepEl.dataset.kit034Step)];
        if (self.select(step, Number(pill.dataset.optionIndex), pill.dataset.kit034Value)) {
          self.refreshStep(step);
          self.steps.forEach(function (s) { if (s !== step) self.refreshStep(s); });
          self.hideMessage();
          self.updateNav();
        }
        return;
      }
      var edit = e.target.closest('[data-kit034-edit]');
      if (edit) {
        self.go(Number(edit.dataset.kit034Edit), true);
      }
    });
    this.prevBtn.addEventListener('click', function () {
      if (self.current > 0 && !self.busy) self.go(self.current - 1, true);
    });
    this.nextBtn.addEventListener('click', function () { self.onNext(); });
  };

  KitBuilder.prototype.onNext = function () {
    if (this.busy) return;
    if (this.current < this.total) {
      var step = this.steps[this.current];
      if (!step.variant) {
        this.showMessage(this.L.selectOptions, 'error');
        var first = $(step.el, '[data-kit034-value]:not([aria-disabled="true"])');
        if (first) first.focus();
        return;
      }
      if (this.current < this.total - 1) return this.go(this.current + 1, true);
      if (this.summary) return this.go(this.total, true);
      return this.addToCart();
    }
    this.addToCart();
  };

  KitBuilder.prototype.go = function (idx, userInitiated) {
    var self = this;
    var onSummary = !!this.summary && idx === this.total;
    this.current = idx;
    this.steps.forEach(function (s, i) { s.el.hidden = onSummary || i !== idx; });
    if (this.summary) {
      this.summary.hidden = !onSummary;
      if (onSummary) this.renderSummary();
    }
    this.hideMessage();
    this.updateProgress();
    this.updateNav();
    if (!onSummary) this.updateGallery(this.steps[idx]);

    if (userInitiated) {
      var focusTarget = onSummary
        ? $(this.summary, '.kit034__summary-title')
        : $(this.steps[idx].el, '[data-kit034-card-name]');
      if (focusTarget) {
        try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
      }
      var rect = this.root.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var y = window.scrollY + rect.top - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  };

  KitBuilder.prototype.updateProgress = function () {
    var onSummary = this.current >= this.total;
    var now = onSummary ? this.total : this.current + 1;
    var text = onSummary && this.summary
      ? (this.L.summaryProgress || '')
      : fill(this.L.progress, { atual: String(now), total: String(this.total) });
    var pct = onSummary ? 100 : (now / this.total) * 100;
    if (this.fillEl) this.fillEl.style.width = pct + '%';
    if (this.progressText) this.progressText.textContent = text;
    if (this.bar) {
      this.bar.setAttribute('aria-valuenow', String(now));
      this.bar.setAttribute('aria-valuetext', text);
    }
  };

  KitBuilder.prototype.updateNav = function () {
    if (this.busy) return;
    this.prevBtn.disabled = this.current === 0;
    var label;
    var ready;
    if (this.current < this.total) {
      var last = this.current === this.total - 1;
      label = !last ? this.L.next : (this.summary ? this.L.review : this.L.finish);
      ready = !!this.steps[this.current].variant;
    } else {
      label = this.L.finish;
      ready = this.steps.every(function (s) { return !!s.variant; });
    }
    this.nextBtn.textContent = label;
    this.nextBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
  };

  KitBuilder.prototype.renderSummary = function () {
    var self = this;
    var list = $(this.summary, '[data-kit034-summary-list]');
    list.innerHTML = '';
    var sum = 0;
    this.steps.forEach(function (step, i) {
      var v = step.variant;
      var li = document.createElement('li');
      li.className = 'kit034__summary-item';

      var media = document.createElement('div');
      media.className = 'kit034__summary-img';
      var src = (v && imageFor(step.product, v.options)) || step.product.image;
      if (src) {
        var im = document.createElement('img');
        im.src = sizeUrl(src, 160);
        im.alt = '';
        im.loading = 'lazy';
        im.width = 56;
        im.height = 70;
        media.appendChild(im);
      }

      var info = document.createElement('div');
      info.className = 'kit034__summary-info';
      var name = document.createElement('span');
      name.className = 'kit034__summary-name';
      name.textContent = (i + 1) + '. ' + step.product.title;
      info.appendChild(name);
      if (v && !hasOnlyDefault(step.product)) {
        var meta = document.createElement('span');
        meta.className = 'kit034__summary-meta';
        meta.textContent = step.product.options.map(function (n, j) { return n + ': ' + v.options[j]; }).join(' · ');
        info.appendChild(meta);
      }
      var price = document.createElement('span');
      price.className = 'kit034__summary-price';
      price.textContent = v ? self.formatMoney(v.price) : '—';
      info.appendChild(price);
      if (v) sum += v.price;

      var edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'kit034__edit';
      edit.dataset.kit034Edit = String(i);
      edit.textContent = self.L.edit || '';
      edit.setAttribute('aria-label', fill(self.L.editAria || self.L.edit, { n: String(i + 1) }) + ' — ' + step.product.title);

      li.appendChild(media);
      li.appendChild(info);
      li.appendChild(edit);
      list.appendChild(li);
    });

    $(this.summary, '[data-kit034-sum-total]').textContent = this.formatMoney(sum);

    var kitPrice = Number(this.cfg.kitPrice) || 0;
    var pct = Number(this.cfg.discountPercent) || 0;
    var target = 0;
    if (kitPrice > 0 && kitPrice < sum) target = kitPrice;
    else if (pct > 0 && this.total >= (Number(this.cfg.discountMinItems) || 1)) target = Math.round(sum * (1 - pct / 100));

    var priceRow = $(this.summary, '[data-kit034-kit-price-row]');
    var saveRow = $(this.summary, '[data-kit034-savings-row]');
    if (target > 0 && target < sum) {
      $(this.summary, '[data-kit034-kit-price]').textContent = this.formatMoney(target);
      $(this.summary, '[data-kit034-savings]').textContent = this.formatMoney(sum - target);
      priceRow.hidden = false;
      saveRow.hidden = false;
    } else {
      priceRow.hidden = true;
      saveRow.hidden = true;
    }
  };

  /* ---------------- messages ---------------- */

  KitBuilder.prototype.showMessage = function (text, tone) {
    if (!this.msg || !text) return;
    this.msg.dataset.tone = tone || 'info';
    this.msg.setAttribute('role', tone === 'error' ? 'alert' : 'status');
    this.msg.textContent = text;
    this.msg.hidden = false;
  };

  KitBuilder.prototype.hideMessage = function () {
    if (!this.msg) return;
    this.msg.hidden = true;
    this.msg.textContent = '';
  };

  /* ---------------- add to cart ---------------- */

  KitBuilder.prototype.addToCart = function () {
    var self = this;
    var missing = this.steps.findIndex(function (s) { return !s.variant; });
    if (missing > -1) {
      this.go(missing, true);
      this.showMessage(this.L.selectOptions, 'error');
      return;
    }

    var kitId = 'K' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
    var items = this.steps.map(function (s, i) {
      return {
        id: s.variant.id,
        quantity: 1,
        properties: {
          _kit: self.cfg.kitTitle,
          _kit_id: kitId,
          _kit_item: (i + 1) + '/' + self.total,
        },
      };
    });

    var sectionIds = [];
    $$(document, 'cart-items-component[data-section-id]').forEach(function (el) {
      if (sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
    });

    this.busy = true;
    this.nextBtn.classList.add('is-loading');
    this.nextBtn.setAttribute('aria-disabled', 'true');
    this.prevBtn.disabled = true;
    this.nextBtn.textContent = this.L.loading;
    this.hideMessage();

    var body = { items: items };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    var addResponse;
    fetchWithTimeout(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }, 15000)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var err = new Error(res.json.description || res.json.message || 'add failed');
          err.userMessage = res.json.description || res.json.message;
          throw err;
        }
        addResponse = res.json;
        return fetchWithTimeout(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) { return self.dispatchCartAdd(cart, addResponse); })
      .then(function () {
        self.busy = false;
        self.nextBtn.classList.remove('is-loading');
        self.nextBtn.textContent = self.L.added;
        self.showMessage(self.L.success, 'success');
        self.openDrawer();
        setTimeout(function () { self.updateNav(); }, 2500);
        self.prevBtn.disabled = self.current === 0;
      })
      .catch(function (err) {
        console.error('[kit034] add error', err);
        self.busy = false;
        self.nextBtn.classList.remove('is-loading');
        self.updateNav();
        self.showMessage(err && err.userMessage ? err.userMessage : self.L.error, 'error');
      });
  };

  KitBuilder.prototype.dispatchCartAdd = function (cart, response) {
    var root = this.root;
    var data = {
      source: 'combo-builder',
      itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
      productId: String(this.cfg.kitProductId || ''),
      sections: (response && response.sections) || {},
    };
    var fallback = function () {
      root.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart || {}, sourceId: root.id, data: data },
      }));
    };
    var p;
    try {
      p = import('@theme/events').then(function (mod) {
        if (mod && mod.CartAddEvent) root.dispatchEvent(new mod.CartAddEvent(cart || {}, root.id, data));
        else fallback();
      }, fallback);
    } catch (e) {
      fallback();
      p = Promise.resolve();
    }
    return p;
  };

  KitBuilder.prototype.openDrawer = function () {
    if (!this.cfg.openDrawer) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.hasAttribute('auto-open')) return;
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) return;
    // Let the drawer morph the new sections first.
    requestAnimationFrame(function () {
      if (typeof drawer.open === 'function') drawer.open();
      else if (typeof drawer.showDialog === 'function') drawer.showDialog();
    });
  };

  /* ---------------- boot ---------------- */

  function boot(scope) {
    $$(scope || document, '[data-kit034]').forEach(function (el) {
      if (el.__kit034) return;
      try {
        el.__kit034 = new KitBuilder(el);
      } catch (e) {
        console.error('[kit034] init error', e);
      }
    });
  }

  window.Outlet034KitBuilder = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target && e.target.closest ? e.target.closest('.shopify-section') : document); });
})();
